const tasks = [
  {
    icon: 'ri-vip-crown-line',
    title: 'Подготовка будущих руководителей',
    desc: 'Компания заранее развивает сотрудников, которые потенциально могут возглавить подразделения.',
  },
  {
    icon: 'ri-user-search-line',
    title: 'Снижение зависимости от внешнего найма',
    desc: 'Часть вакансий можно закрывать внутренними кандидатами.',
  },
  {
    icon: 'ri-archive-line',
    title: 'Сохранение экспертизы',
    desc: 'Знания и опыт остаются внутри компании.',
  },
  {
    icon: 'ri-rocket-line',
    title: 'Подготовка к росту компании',
    desc: 'При масштабировании появляются новые роли и подразделения, и компания заранее формирует людей под них.',
  },
  {
    icon: 'ri-links-line',
    title: 'Преемственность',
    desc: 'Ключевые позиции не должны становиться критической точкой при уходе конкретного человека.',
  },
  {
    icon: 'ri-user-star-line',
    title: 'Мотивация сильных сотрудников',
    desc: 'Сотрудник видит возможную траекторию профессионального развития внутри компании.',
  },
  {
    icon: 'ri-compass-3-line',
    title: 'Управляемое развитие',
    desc: 'Компания понимает, какие компетенции необходимо развивать у будущих руководителей и специалистов.',
  },
];

export default function WhyCompanyNeeds() {
  return (
    <section id="tasks" className="py-16 md:py-24 bg-gray-50">
      <div className="max-w-7xl mx-auto px-6">
        <h2 className="text-2xl md:text-4xl font-bold text-gray-900 text-center mb-4">
          Зачем компании нужен кадровый резерв
        </h2>
        <p className="text-base md:text-lg text-gray-600 text-center max-w-3xl mx-auto mb-14 leading-relaxed">
          Какие задачи решает система кадрового резерва
        </p>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5 md:gap-6">
          {tasks.map((t, i) => (
            <div key={i} className="bg-white rounded-xl border border-gray-200 p-5 md:p-6 hover:border-teal-200 transition-colors group">
              <div className="w-11 h-11 bg-teal-100 rounded-lg flex items-center justify-center mb-4 group-hover:bg-teal-200 transition-colors">
                <i className={`${t.icon} text-xl text-teal-700`}></i>
              </div>
              <h3 className="text-lg font-bold text-gray-900 mb-2">{t.title}</h3>
              <p className="text-sm text-gray-600 leading-relaxed">{t.desc}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}